export const SIZE = {
    small_alt: 'small_alt',
    small: 'small',
    medium: 'medium',
};
export const FONT_NORMAL = 'normal';
export const NEW_TAG_CLASS = 'custom-tag';
export const OLD_TAG_CLASS = 'default-tag';
export const FEW_LEFT = 'Few Left';
export const LEFT = 'Left!';
export const OFF = 'Off!';
export const defaultTranslationKeys = {
    outOfStock: 'Out Of Stock',
    fewLeft: 'Few Left',
    quantityLeft: LEFT,
    variant: '',
    variants: '',
    discount: OFF,
};
export const rupeeSymbol = '₹';
export const percentSymbol = '%';
export const TOTAL_RATE = 5;
export const GRADIENT_BG = 'https://images-static.nykaa.com/media/Background.png';
export const WISHLIST_CTA_LABEL = 'add to wishlist';
